import script from "./PlayerPlaylist.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerPlaylist.vue?vue&type=script&setup=true&lang=js"

import "./PlayerPlaylist.vue?vue&type=style&index=0&id=4ed0a6a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed0a6a2"]])

export default __exports__